<template>
  <div class="p-0 col-12 animated fadeIn">
    <kendo-datasource ref="datasource1"
        :transport-read="getParents"
        :schema="schema"
        :schema-model-id="'uid'"
        :batch='true'
        :page-size='limit'
        :page="page"
        :server-paging='true'
        :server-sorting='true'
        :sort="{ field: 'name', dir: 'asc' }">
    </kendo-datasource>
    <kendo-grid ref="gridComponent" :data-source-ref="'datasource1'"
      :filterable='false'
      :pageable="{ pageSizes: [10, 15, 25, 50], buttonCount: 3, input: true }"
      :sortable='true'
      :resizable='true'>
      <kendo-grid-column field="name" title="Parent Name" template="#= parent_name.toUpperCase() #"></kendo-grid-column>
      <kendo-grid-column field="meta" title="Product Meta" template="#= meta.template(meta.value) #"></kendo-grid-column>
      <kendo-grid-column field="description" title="Description" template="<p class='text-description'>#= description #</div>"></kendo-grid-column>
    </kendo-grid>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // data here
      schema: {
        total: 'count',
        data: 'results',
        parse: function (response) {
          var data = response.results
          console.log(data)
          for (var i = 0; i < data.length; i++) {
            data[i].meta = {
              value: data[i].meta,
              template: function (meta) {
                if (meta) {
                  var templateStr = '<div class"d-block">'
                  for (var i = 0; i < meta.length; i++) {
                    templateStr += '<span class="badge badge-light d-inline-block" style="padding: 5px;margin: 0px 5px; font-size: 13px">' + meta[i] + '</span>'
                  }
                  templateStr += '</div>'
                  return templateStr
                } else {
                  return ''
                }
              }
            }
            if (!data[i].description) {
              data[i].description = ''
            }
          }
          return response
        }
      },
      limit: 15,
      page: 1
    }
  },
  mounted () {
    this.getParents()
  },
  methods: {
    getParents (event) {
      var vm = this
      var limit = event.data.take
      var offset = event.data.skip

      var baseUri = 'api/sales/products/parents/?limit=' + limit + '&offset=' + offset
      var sort = ''
      if (event.data.sort && event.data.sort.length > 0) {
        var temp = event.data.sort[0]
        sort = temp.field + '-' + temp.dir
      }
      if (sort.length > 0) {
        baseUri += '&sort=' + sort
      }
      vm.axios.get(baseUri)
        .then(
          (response) => {
            event.success(response.data)
          }
        )
    }
  }
}
</script>

<style>
  .text-description {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 20px;     /* fallback */
    max-height: 40px;      /* fallback */
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
</style>



// WEBPACK FOOTER //
// src/views/product/ParentProduct.vue